import React from "react";
import { useSelector } from "react-redux";

import styles from "./DeliveryTypeSelector.module.scss";
import { DeliveryType } from "../../../common/types/enums";
import { selectClusterList } from "../../../store/slices/clusterListSlice";
import { getDeliveryTypeIcon } from "../../../common/utils/functions/enumToIcon";
import { getDeliveryTypeText } from "../../../common/utils/functions/enumToText";

interface Props {
  clusterId: number;
  deliveryType: DeliveryType;
  onSelect: (type: DeliveryType) => void;
}

export const DeliveryTypeSelector: React.FC<Props> = ({
  clusterId,
  deliveryType,
  onSelect,
}) => {
  const clusters = useSelector(selectClusterList);
  const currentCluster = clusters.find((c) => Number(c.id) === clusterId);

  const deliveryOptions = [
    {
      type: DeliveryType.DELIVERY,
      icon: getDeliveryTypeIcon(DeliveryType.DELIVERY),
      label: getDeliveryTypeText(DeliveryType.DELIVERY),
    },
    {
      type: DeliveryType.PICKUP,
      icon: getDeliveryTypeIcon(DeliveryType.PICKUP),
      label: getDeliveryTypeText(DeliveryType.PICKUP),
    },
  ];

  const visibleOptions = deliveryOptions.filter((el) =>
    !currentCluster?.withDelivery ? el.type !== DeliveryType.DELIVERY : true,
  );

  return (
    <div className={styles.Container}>
      <h3 className={styles.Title}>Способ получения</h3>

      <div className={styles.Options}>
        {visibleOptions.map((option) => {
          const Icon = option.icon;
          const isActive = deliveryType === option.type;
          return (
            <button
              key={option.type}
              type="button"
              className={`${styles.Option} ${isActive ? styles.Active : ""}`}
              onClick={() => onSelect(option.type)}
            >
              {Icon && <Icon className={styles.Icon} />}
              <span className={styles.Label}>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
